module.exports = __webpack_public_path__ + "static/media/icon-close.13688135.svg";